<template>
    <div>
        <b-btn variant="secondary" @click="download()">Download Excel</b-btn>
        <vue-good-table
            class="mt-3"
            :columns="columns"
            :rows="measureTypesList"
            :search-options="{
                enabled: true,
                placeholder: 'Cerca misura',
            }"
            :pagination-options="{
                enabled: true,
                position: 'bottom',
                perPageDropdown: [20, 50, 100],
                dropdownAllowAll: true,
                setCurrentPage: 1,
                jumpFirstOrLast : true,
                firstLabel : 'Prima pagina',
                lastLabel : 'Ultima pagina',
                nextLabel: 'Successiva',
                prevLabel: 'Precedente',
                rowsPerPageLabel: 'Misure per pagina',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'Tutti',
            }"
        ></vue-good-table>
    </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import XLSX from 'xlsx';

export default {
    name: "MeasureTypesList",
    components: { VueGoodTable },
    data() {
        return {
            measureTypesList: [],
            columns: [
                {
                    label: 'Nome',
                    field: 'name',
                    sortable: true,
                },
                {
                    label: 'Codice',
                    field: 'code',
                    sortable: true,
                },
            ],
        }
    },
    created() {
        if(this.measureTypesList.length == 0) {
            this.$store.commit("loading")
            this.$store.dispatch('sites/measureTypesList').then((data) => {
                this.measureTypesList = data.sort((a, b) => {
                    if(a.name > b.name) {
                        return 1;
                    }
                    return -1;
                });
                this.$store.commit("stopLoading");
            });
        }  
    },
    methods: {
        download() {
            let arrayMeasures = [];
            this.measureTypesList.forEach(item => {
                arrayMeasures.push([ item.name, item.code ]);
            })
            
            const ws = XLSX.utils.aoa_to_sheet(arrayMeasures);
            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, ws, 'Misure');

            XLSX.writeFile(wb, "misure_analytics.xlsx");
        }
    }
}   
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Admin/MeasureTypes/MeasureTypesList.vue